/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesSupportDtosCreateSupportTicketRequest,
  FacilityFlowCoreModulesSupportDtosReplyToSupportTicketRequest,
  FacilityFlowCoreModulesSupportDtosSupportTicketDto,
  GetApiV1MeSupportTicketsParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getMeSupportTickets = () => {
const getApiV1MeSupportTickets = (
    params?: GetApiV1MeSupportTicketsParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto[]>(
      {url: `/api/v1/me/support/tickets`, method: 'GET',
        params
    },
      options);
    }
  const postApiV1MeSupportTickets = (
    facilityFlowCoreModulesSupportDtosCreateSupportTicketRequest: FacilityFlowCoreModulesSupportDtosCreateSupportTicketRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto>>,) => {
      return customInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto>(
      {url: `/api/v1/me/support/tickets`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesSupportDtosCreateSupportTicketRequest
    },
      options);
    }
  const getApiV1MeSupportTicketsId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto>>,) => {
      return customInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto>(
      {url: `/api/v1/me/support/tickets/${id}`, method: 'GET'
    },
      options);
    }
  const postApiV1MeSupportTicketsIdReplies = (
    id: string,
    facilityFlowCoreModulesSupportDtosReplyToSupportTicketRequest: FacilityFlowCoreModulesSupportDtosReplyToSupportTicketRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto>>,) => {
      return customInstance<FacilityFlowCoreModulesSupportDtosSupportTicketDto>(
      {url: `/api/v1/me/support/tickets/${id}/replies`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesSupportDtosReplyToSupportTicketRequest
    },
      options);
    }
  return {getApiV1MeSupportTickets,postApiV1MeSupportTickets,getApiV1MeSupportTicketsId,postApiV1MeSupportTicketsIdReplies}};
export type GetApiV1MeSupportTicketsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeSupportTickets>['getApiV1MeSupportTickets']>>>
export type PostApiV1MeSupportTicketsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeSupportTickets>['postApiV1MeSupportTickets']>>>
export type GetApiV1MeSupportTicketsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeSupportTickets>['getApiV1MeSupportTicketsId']>>>
export type PostApiV1MeSupportTicketsIdRepliesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeSupportTickets>['postApiV1MeSupportTicketsIdReplies']>>>
